/**
 * Shared helpers for location-details forms (contact-details, address-form, etc.).
 */

export const ADDRESS_UPDATE_FIELDS = [
  'branch',
  'street_address',
  'city',
  'state',
  'country',
  'zip_code',
  'timezone',
] as const;

export const CONTACT_UPDATE_FIELDS = ['email', 'contact'] as const;

export const HOURS_UPDATE_FIELDS = ['hours'] as const;

export interface BuildLocationUpdatePayloadOptions {
  allowedFields: readonly string[];
}

/**
 * Build payload for updateLocationDetails: only include whitelisted form fields.
 */
export function buildLocationUpdatePayload(
  formValue: Record<string, any>,
  options: BuildLocationUpdatePayloadOptions
): Record<string, any> {
  const payload: Record<string, any> = {};
  for (const key of options.allowedFields) {
    if (key in formValue) {
      payload[key] = formValue[key];
    }
  }
  return payload;
}
